import { Injectable } from '@angular/core';

import { Address } from '../../../../../Domain/Model/address';

import GeocoderResponse = google.maps.GeocoderResponse;

@Injectable({
    providedIn: 'root'
})
export class GoogleGeocodingResultToAddressMapperService {
    map(response: GeocoderResponse): Address[] {
        // Filter results to include only specific address types
        const validTypes = ['street_number', 'street_address', 'premise', 'subpremise', 'establishment'];
        const relevantResults = response.results.filter(result => result.types.some(type => validTypes.includes(type)));

        return relevantResults.map(result => {
            const components = result.address_components;

            // Extract address components by type
            const getComponent = (type: string): string => {
                const component = components.find(c => c.types.includes(type));
                return component ? component.short_name : '';
            };

            return new Address(
                getComponent('street_number'),
                getComponent('route'),
                getComponent('locality') || getComponent('sublocality'), // Fallback to sublocality
                getComponent('administrative_area_level_1'),
                getComponent('postal_code'),
                result.formatted_address
            );
        });
    }
}
